<template>
  <div>
    <wc-page-title :loading='isLoading' title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Work Order Search by Category'
            titleIcon='mdi-text-box-search-outline'
          >
            <v-card-text>
              <v-form v-model='isValidForm'>
                <v-row>
                  <v-col cols="4">
                    <v-select
                      :items='divisions'
                      :loading='loadingDefaultInfo'
                      item-text='division'
                      item-value='id'
                      v-model='item.division'
                      :rules="[rules.required]"
                      label='Division'
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items='filteredWOTypes'
                      :loading='loadingDefaultInfo'
                      item-text='name'
                      item-value='id'
                      label='Work order type'
                      v-model='item.wo_type'
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      v-model='item.status'
                      :items="['Open', 'Closed', 'All']"
                      :loading='loadingDefaultInfo'
                      item-text='name'
                      item-value='id'
                      label='Status'
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
              <v-btn
                small
                depressed
                color='success'
                :disabled='!isValidForm'
                @click='runReport'
                :loading='isLoading'
              >Find Work Orders</v-btn>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>
      <v-row v-if='hasSearched'>
        <v-col cols='12'>
          <wc-data-box
            title='Search Results'
            titleIcon='mdi-finance'
            showSearch
            v-model='search'
          >
            <v-data-table
              :items='result'
              :headers='headers'
              :loading='loadingResults'
              :search='search'
              dense
              :items-per-page='20'
              @click:row='open'
            >
              <template v-slot:item.date_created='{ item }'>
                {{ item.date_created | shortDate }}
              </template>
              <template v-slot:item.date_completed='{ item }'>
                {{ item.date_completed | shortDate }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import settingsAPI from '@/modules/settings/api/settings';
import managementAPI from '@/modules/management/api/index';
import formRules from '@/mixins/formRules';
import wosAPI from '@/modules/wos/api/index';
import _ from 'lodash';

export default {
  name: 'work-order-dashboard',
  data: () => ({
    isLoading: false,
    loadingDefaultInfo: false,
    hasSearched: false,
    loadingResults: false,
    isValidForm: false,
    invs: [],
    woTypes: [],
    result: [],
    divisions: [],
    division: '',
    search:'',
    headers: [
      { text: 'Connected project name', value: 'project_name' },
      { text: 'Work order number', value: 'number' },
      { text: 'Date Created', value: 'date_created' },
      { text: 'Date Completed', value: 'date_completed' },
      { text: 'Work order type', value: 'wo_type_name' }
    ],
    item: { status: 'All', division: '', wo_type: '' }
  }),
  mixins: [formRules],
  mounted () {
    this.getGeneralInfo()
  },
  computed: {
    filteredWOTypes() {
      if (this.item.division) {
        return _.filter(this.woTypes, {division: this.item.division})
      } else {
        return this.woTypes
      }
    }
  },
  methods: {
    async getGeneralInfo () {
      this.loadingDefaultInfo = true
      this.divisions = await settingsAPI.getDivisions()
      this.woTypes = await managementAPI.getWOTypes()
      this.loadingDefaultInfo = false
    },
    async runReport () {
      this.loadingResults = true
      this.hasSearched = true
      let query = '?wo_type__division=' + this.item.division
      if (this.item.status === 'Open') {
        query += '&is_complete=False&archived=False'
      } else if (this.item.status === 'Closed') {
        query += '&is_complete=True&archived=True'
      }
      if (this.item.wo_type !== '') {
        query += '&wo_type=' + this.item.wo_type
      }
      this.result = await wosAPI.wosReport(query)
      this.loadingResults = false
    },
    open (wo) {
      this.$router.push({ name: 'WOOverview', params: { id: wo.id }})
    },
  }
}
</script>
